<template>
  <b-overlay id="spinner-finalizar-pedido" :show="show" rounded="sm">
    <b-overlay id="spinner-cancelar-pedido" :show="$store.state['SLS_PedidosVendas'].setIsLoadingCancelarPedido"
      rounded="sm">
      <b-col lg="12">

        <b-col>
          <div class="demo-inline-spacing">
            <b-button class="mr-2 bg-secondary bg-darken-2 border-0" :to="{ name: 'pedidos-vendas' }"
              v-if="showSalvar === false" @click="voltar">
              <feather-icon icon="ArrowLeftCircleIcon" size="18" />
              Voltar
            </b-button>
            <b-button class="mr-2 bg-warning bg-darken-2 border-0"
              v-if="botoesExibir && botoesExibir.includes('Alterar') && showSalvar === false" @click="alterar()"
              :disabled="getCapaPedido.pedidositcomercial === 'IMPLANTADO'">
              <feather-icon icon="Edit2Icon" size="18" />
              Alterar
            </b-button>
            <b-button class="mr-2 bg-dark bg-darken-2 border-0"
              v-if="botoesExibir && botoesExibir.includes('Finalizar') && showSalvar === false"
              @click="finalizarPedido()" :disabled="getCapaPedido.pedidositcomercial === 'IMPLANTADO'">
              <feather-icon icon="CheckCircleIcon" size="18" />
              Finalizar
            </b-button>
            <b-button class="mr-2 bg-danger bg-darken-2 border-0"
              v-if="botoesExibir && botoesExibir.includes('Cancelar') && showSalvar === false" @click="cancelar()">
              <feather-icon icon="XCircleIcon" size="18" />
              Cancelar
            </b-button>
            <b-button class="mr-2 bg-success bg-darken-2 border-0" v-if="showSalvar" @click="salvarPedido()">
              <feather-icon icon="CheckCircleIcon" size="18" />
              Salvar
            </b-button>
            <b-button class="mr-2 bg-danger bg-darken-2 border-0"
              v-if="botoesExibir && botoesExibir.includes('Cancelar') && showSalvar === true"
              @click="cancelarAlteracoes()">
              <feather-icon icon="XCircleIcon" size="18" />
              Cancelar Alterações
            </b-button>
            <b-button class="mr-2 bg-success bg-darken-2 border-0"
              v-if="botoesExibir && botoesExibir.includes('Copiar') && showSalvar === false" @click="copiarPedido">
              <feather-icon icon="CopyIcon" size="18" />
              Copiar
            </b-button>
            <!--        <b-button-->
            <!--            class="mr-2 bg-warning bg-darken-2 border-0"-->
            <!--        >-->
            <!--          <feather-icon icon="AlignJustifyIcon" class="rotate-icon" size="18"/>-->
            <!--          Boleto-->
            <!--        </b-button>-->
          </div>
        </b-col>

        <b-col md="12" class="mt-2">
          <b-card no-body>
            <b-card-header :header-bg-variant="`secondary bg-lighten-5`" class="w-100">
              <b-card-title>Pedidos</b-card-title>
              <div class="demo-inline-spacing">
                <h3 v-if="getCapaPedido.pedidonumerointegracao !== 'RASCUNHO'">
                  <b-badge size="xl" variant="success">
                    NR Pré-Pedido: {{ getCapaPedido.pedidonumerocliente }}
                  </b-badge>
                </h3>
                <h3
                  v-if="getCapaPedido.pedidonumerointegracao != getCapaPedido.pedidoid && getCapaPedido.pedidonumerointegracao !== 'RASCUNHO'">
                  <b-badge variant="success">
                    Pedido ERP: {{ getCapaPedido.pedidonumerointegracao }}
                  </b-badge>
                </h3>
              </div>
            </b-card-header>
            <b-tabs card pills nav-class="nav-pill-primary">
              <b-tab>
                <template #title>
                  <feather-icon icon="PocketIcon" />
                  <span>Condições</span>
                </template>
                <b-overlay id="spinner-capa-pedido"
                  :show="$store.state['SLS_PedidosVendas'].setIsLoadinglistarCapaPedido" rounded="sm">
                  <b-row>
                    <b-col class="mt-2 mb-2">
                      <b-row class="mb-12">
                        <b-col md="3">
                          <b-form-group label="NR Pré-Pedido">
                            <b-form-input type="number" placeholder="" v-model="getCapaPedido.pedidonumerocliente" disabled />
                          </b-form-group>
                        </b-col>
                        <b-col md="6">
                          <b-form-group label="Pedido ERP">
                            <b-form-input type="number" placeholder="" v-model="getCapaPedido.pedidonumerointegracao"
                              disabled />
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group label="Status">
                            <b-form-input type="text" placeholder="" v-model="getCapaPedido.pedidoSitSales" disabled />
                          </b-form-group>
                        </b-col>

                        <b-col md="2">
                          <b-form-group label="Representante">
                            <b-form-input type="number" placeholder="" v-model="getCapaPedido.representanteid"
                              disabled />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group label="Nome representante">
                            <b-form-input type="text" placeholder="" v-model="getCapaPedido.representantenome"
                              disabled />
                          </b-form-group>
                        </b-col>
                        <b-col md="2">
                          <b-form-group label="Estabelecimento">
                            <b-form-input type="number" placeholder="" v-model="getCapaPedido.estabelecimentoId"
                              disabled />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group label="Estabelecimento Razão Social">
                            <b-form-input type="text" placeholder="" v-model="getCapaPedido.estabelecimentorazaosocial"
                              disabled />
                          </b-form-group>
                        </b-col>

                        <b-col md="2">
                          <b-form-group label="Cliente">
                            <b-form-input type="number" placeholder="" v-model="getCapaPedido.clienteiderp" disabled />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group label="Cliente Razão Social">
                            <b-form-input type="text" placeholder="" v-model="getCapaPedido.clienterazaosocial"
                              disabled />
                          </b-form-group>
                        </b-col>
                        <b-col md="2">
                          <b-form-group label="Condição de Pagamento">
                            <b-input-group>
                              <b-form-input type="number" placeholder="" v-model="getCapaPedido.condicaopagamentoid"
                                :disabled="!showSalvar || getCapaPedido.pedidonumerointegracao !== 'RASCUNHO'"
                                @blur="onBlurCondPagamento" />
                              <b-input-group-append>
                                <b-button variant="primary"
                                  v-if="showSalvar && getCapaPedido.pedidonumerointegracao === 'RASCUNHO'"
                                  @click="openModalCondPagamento" v-b-tooltip.hover
                                  title="Abrir lista de condições de pagamento">
                                  <feather-icon icon="SearchIcon" />
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group label="Condição de Pagamento Descrição">
                            <b-form-input type="text" placeholder="" v-model="getCapaPedido.condicaoPagamentoDescricao"
                              disabled />
                          </b-form-group>
                        </b-col>

                        <b-col md="2">
                          <b-form-group label="Tabela de preço">
                            <b-input-group>
                              <b-form-input type="text" placeholder="" v-model="getCapaPedido.tabelaprecoid"
                                :disabled="!showSalvar || getCapaPedido.pedidonumerointegracao !== 'RASCUNHO'"
                                @blur="onBlurTabelaPreco" />
                              <b-input-group-append>
                                <b-button variant="primary"
                                  v-if="showSalvar && getCapaPedido.pedidonumerointegracao === 'RASCUNHO'"
                                  @click="openModalTabelaPreco" v-b-tooltip.hover
                                  title="Abrir lista de tabelas de preço">
                                  <feather-icon icon="SearchIcon" />
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group label="Tabela de preço Descrição">
                            <b-form-input type="text" placeholder="" v-model="getCapaPedido.tabelapreco_descricao"
                              disabled />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group label="Usuário">
                            <b-form-input type="text" placeholder="" v-model="getCapaPedido.usuarioid" disabled />
                          </b-form-group>
                        </b-col>
                        <b-col md="2">
                          <b-form-group label="Data Emissão">
                            <b-form-input :value="formatarData(getCapaPedido.pedidodata)" disabled />
                          </b-form-group>
                        </b-col>

                        <b-col md="2">
                          <b-form-group label="Nr. OC">
                            <b-form-input type="text" placeholder="" v-model="getCapaPedido.pedidooccliente"
                              :disabled="!showSalvar || getCapaPedido.pedidonumerointegracao !== 'RASCUNHO'" />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group label="Prioridade do pedido">
                            <b-form-select v-model="getCapaPedido.pedidoprioridade"
                              :disabled="!showSalvar || getCapaPedido.pedidonumerointegracao !== 'RASCUNHO'"
                              :options="prioridadesPedidoOptions" />
                          </b-form-group>
                        </b-col>

                        <b-col md="12">
                          <b-form-group label="Observações">
                            <b-form-textarea id="textarea-rows" placeholder="Observações...."
                              v-model="getCapaPedido.pedidoobservacoes" rows="8"
                              :disabled="!showSalvar || getCapaPedido.pedidonumerointegracao !== 'RASCUNHO'" />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="12">
                      <hr>
                    </b-col>
                    <b-col class="mt-2 mb-2">
                      <b-card no-body>
                        <b-card-header :header-bg-variant="`secondary bg-lighten-5`" class="w-100">
                          <b-card-title>Total de Pedido</b-card-title>
                        </b-card-header>
                        <b-row class="mb-12 mt-2">
                          <!-- <b-col md="6">
                      <b-form-group label="Valor Total Produtos">
                        <b-form-input type="text" placeholder="" v-model="getCapaPedido.pedidovalortotal" disabled/>
                      </b-form-group>
                    </b-col> -->
                          <b-col md="12" class="ml-1">
                            <b-form-group label="Valor Total Final">
                              <b-form-input type="text" :value="valorTotalFormatado" disabled />
                            </b-form-group>
                          </b-col>
                        </b-row>

                        <!-- DADOS DE IMPOSTO -->
                        <!-- <b-row class="mb-12 mt-2">
                    <b-col md="6">
                      <b-form-group label="Valor IPI">
                        <b-form-input type="text" placeholder="" v-model="getCapaPedido.pedidovaloripi" disabled/>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group label="Valor Base IPI">
                        <b-form-input type="number" placeholder="" v-model="getCapaPedido.pedidovalorbaseipi" disabled/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="mb-12 mt-2">
                    <b-col md="6">
                      <b-form-group label="Valor ICMS">
                        <b-form-input type="text" placeholder="" v-model="getCapaPedido.pedidovaloricms" disabled/>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group label="Valor Base ICMS">
                        <b-form-input type="number" placeholder="" v-model="getCapaPedido.pedidovalorbaseicms" disabled/>
                      </b-form-group>
                    </b-col>
                  </b-row> -->
                      </b-card>
                    </b-col>
                  </b-row>
                </b-overlay>
              </b-tab>

              <b-tab>
                <template #title>
                  <feather-icon icon="ListIcon" />
                  <span>Itens</span>
                </template>
                <b-overlay id="spinner-items" :show="$store.state['SLS_PedidosVendas'].setIsLoadinglistarItensPedido"
                  rounded="sm">
                  <modal-adicionar-editar-itens-pedido-existente ref="adicionar-editar-itens-pedido-existente" />
                  <b-col>
                    <div class="demo-inline-spacing mb-2" v-if="showSalvar">
                      <b-button variant="success" @click="openModal">
                        <feather-icon icon="PlusIcon" size="18" />
                        Novo
                      </b-button>
                    </div>
                  </b-col>

                  <b-table :items="getItensPedido" :fields="fields" striped responsive
                    :striped="true" :bordered="true" :hover="true"
                    v-show="getItensPedido.length > 0">
                    <template #cell(PrecoComImposto)="row">
                      {{ getPrecoComImpostoExibicao(row.item) | formtPriceBr }}
                    </template>
                    <template #cell(valorTotalComImposto)="row">
                      {{ formatItemTotal(row.item.valorTotalComImposto, row.item.ValorTotal) }}
                    </template>
                    <template #cell(excluir)="data">
                      <b-button size="sm" class="mr-2 bg-danger bg-darken-5 border-0" @click="removeItem(data.index)">
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </template>
                    <template #cell(editar)="data">
                      <b-button size="sm" class="mr-2 bg-primary bg-darken-2 border-0">
                        <feather-icon icon="EditIcon" class="rotate-icon" />
                      </b-button>
                    </template>
                    <template #cell(mostrar_detalhes)="row">
                      <b-form-checkbox v-model="row.detailsShowing" plain class="vs-checkbox-con"
                        @change="row.toggleDetails">
                        <span class="vs-checkbox">
                          <span class="vs-checkbox--check">
                            <i class="vs-icon feather icon-check" />
                          </span>
                        </span>
                        <span class="vs-label">{{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }}</span>
                      </b-form-checkbox>
                    </template>

                    <template #row-details="row">
                      <b-card>
                        <b-table responsive="sm" :fields="fieldsSub" :items="row.item.itens" :striped="true"
                          :bordered="true" :hover="true" table-variant="outline-secondary">
                          <template #cell(pedidoItemQuantidade)="subRow" v-if="showSalvar">
                            <div class="d-flex align-items-center justify-content-center">
                              <b-button size="sm" variant="outline-danger" class="mr-1"
                                @click="decrementQuantity(subRow.item)" :disabled="!isValidDecrement(subRow.item)"
                                :title="getMultiploTooltip(subRow.item)">
                                <feather-icon icon="MinusIcon" size="14" />
                              </b-button>
                              <b-form-input
                                v-model.number="subRow.item.pedidoItemQuantidade"
                                type="number"
                                :min="subRow.item.itemMultiplo || 1"
                                :step="subRow.item.itemMultiplo || 1"
                                @input="handleQuantityInput(subRow.item, $event)"
                                @blur="validateQuantityOnBlur(subRow.item)"
                                @keydown="preventInvalidInput"
                                class="mx-1 text-center"
                                style="width: 70px; padding: 2px 5px;"
                              />
                              <b-button size="sm" variant="outline-success" class="ml-1"
                                @click="incrementQuantity(subRow.item)" :disabled="!isValidIncrement(subRow.item)"
                                :title="getMultiploTooltip(subRow.item)">
                                <feather-icon icon="PlusIcon" size="14" />
                              </b-button>
                            </div>
                          </template>
                          <template #cell(pedidoItemQuantidade)="subRow" v-else>
                            {{ subRow.item.pedidoItemQuantidade }}
                          </template>
                          <template #cell(precoComImposto)="row">
                            {{ getPrecoComImpostoExibicao(row.item) | formtPriceBr }}
                          </template>
                          <template #cell(valorTotalComImposto)="row">
                            {{ formatItemTotal(row.item.valorTotalComImposto, row.item.valorTotal || row.item.valorTotalItem || row.item.pedidoItemTotalMercadoria) }}
                          </template>
                          <template #cell(excluir)="subRow" v-if="showSalvar">
                            <b-button size="sm" variant="outline-danger" @click="removeSubItem(subRow.item)">
                              <feather-icon icon="TrashIcon" />
                            </b-button>
                          </template>
                        </b-table>

                        <b-button size="sm" variant="outline-secondary" @click="row.toggleDetails">
                          Ocultar Detalhes
                        </b-button>
                      </b-card>
                    </template>
                  </b-table>
                </b-overlay>
              </b-tab>

              <b-tab>
                <template #title>
                  <feather-icon icon="TruckIcon" />
                  <span>Entrega</span>
                </template>
                <b-overlay id="spinner-endereco"
                  :show="$store.state['SLS_PedidosVendas'].setIsLoadinglistarEntregaPedido" rounded="sm">
                  <b-row>
                    <b-col md="2">
                      <b-form-group label="Data Estimada Entrega">
                        <b-form-input type="date" placeholder=""
                          :value="dataEntregaExibicao"
                          @input="handleDateChange"
                          :disabled="!showSalvar" :min="todayISO" />
                      </b-form-group>
                    </b-col>
                    <b-col md="3">
                      <b-form-group label="Endereço">
                        <b-form-input type="text" placeholder="" v-model="getEnderecoEntrega.clienteendereco"
                          disabled />
                      </b-form-group>
                    </b-col>
                    <b-col md="2">
                      <b-form-group label="CEP">
                        <b-form-input type="number" placeholder="" v-model="getEnderecoEntrega.clienteenderecocep"
                          disabled />
                      </b-form-group>
                    </b-col>

                    <b-col md="2">
                      <b-form-group label="Bairro">
                        <b-form-input type="text" placeholder="" v-model="getEnderecoEntrega.clienteenderecobairro"
                          disabled />
                      </b-form-group>
                    </b-col>
                    <b-col md="2">
                      <b-form-group label="Cidade">
                        <b-form-input type="text" placeholder="" v-model="getEnderecoEntrega.clienteenderecocidade"
                          disabled />
                      </b-form-group>
                    </b-col>
                    <b-col md="1">
                      <b-form-group label="Estado">
                        <b-form-input type="text" placeholder="" v-model="getEnderecoEntrega.ufid" disabled />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-overlay>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-col>
    </b-overlay>
    <modal-buscar-cond-pagamento />
    <modal-buscar-tabela-preco />
  </b-overlay>
</template>

<script>
import {
  BTabs,
  BTab,
  BCardText,
  BCard,
  BCol,
  BCardHeader,
  BFormSelect,
  BFormInput,
  BRow,
  BFormGroup, BButton, BTable, BFormCheckbox, BCardFooter,
} from 'bootstrap-vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import ModalAdicionarItens from '@/views/app/operacoes/pedidosVendas/modal/modalAdicionarItens.vue';
import { mapActions, mapGetters } from 'vuex';
import Store from '@/store';
import Swal from 'sweetalert2';
import { formtPriceBr } from '@core/utils/filter';
import SLSPedidosService from '@/services/Operacoes/SLSPedidos.service';
import ModalAdicionarEditarItensPedidoExistente
from '@/views/app/operacoes/pedidosVendas/modal/modalAdicionarEditarItensPedidoExistente.vue';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { getParametro, getTotvsBaseUrl } from '@/utils/totvsApi';
import ModalBuscarCondPagamento from '@/components/modal/ModalBuscarCondPagamento.vue';
import ModalBuscarTabelaPreco from '@/components/modal/ModalBuscarTabelaPreco.vue';
import axios from 'axios';
import SLSCondicaoPagamentoService from '@/services/SistemaDKP/SLSCondicaoPagamento.service';
import SLSTabelaPrecoService from '@/services/SistemaDKP/SLSTabelapreco.service';
import SLSEsPrioriService from '@/services/SistemaDKP/SLSEsPriori.service';

const slsPedidosService = new SLSPedidosService();
const slsCondicaoPagamentoService = new SLSCondicaoPagamentoService();
const slsTabelaPrecoService = new SLSTabelaPrecoService();
const slsEsPrioriService = new SLSEsPrioriService();
export default {
  components: {
    ModalAdicionarEditarItensPedidoExistente,
    BCardFooter,
    BButton,
    BFormGroup,
    BRow,
    BFormInput,
    BFormSelect,
    BCardHeader,
    BCol,
    BCard,
    BCardText,
    ModalAdicionarItens,
    BTabs,
    BTab,
    BTable,
    BFormCheckbox,
    AppCollapse,
    AppCollapseItem,
    ModalBuscarCondPagamento,
    ModalBuscarTabelaPreco,
  },
  filters: {
    formtPriceBr,
  },
  data: () => ({
    show: false,
    showSalvar: false,
    isRecalculandoImpostos: false,
    collapseType: 'border',
    todayISO: new Date().toISOString().split('T')[0],
  }),
  mounted() {
    this._ultimaCondPagtoProcessada = null;
    this._ultimaTabelaPrecoProcessada = null;
    this.detalhePedido(this.$route.params.pedidoid, this.$route.params.clienteid);
    this.$root.$on('condpagto:selected', this.handleCondPagamentoSelected);
    this.$root.$on('tabelapreco:selected', this.handleTabelaPrecoSelected);
    slsEsPrioriService.selectPrioridadePedido();
  },
  beforeDestroy() {
    this.$root.$off('condpagto:selected', this.handleCondPagamentoSelected);
    this.$root.$off('tabelapreco:selected', this.handleTabelaPrecoSelected);
  },
  methods: {
    handleTabelaPrecoSelected(item) {
      if (item && item.tabelapreco_id) {
        const tabelaAnterior = this.getCapaPedido.tabelaprecoid;
        this._ultimaTabelaPrecoProcessada = String(item.tabelapreco_id);
        this.$store.commit('SLS_PedidosVendas/SET_CAPA_PEDIDO', {
          ...this.getCapaPedido,
          tabelaprecoid: item.tabelapreco_id,
          tabelapreco_descricao: item.tabelapreco_descricao,
        });

        // Se for rascunho e a tabela mudou, recalcular impostos de todos os itens
        if (
          this.getCapaPedido.pedidonumerointegracao === 'RASCUNHO'
          && String(tabelaAnterior) !== String(item.tabelapreco_id)
          && this.getItensPedido.length > 0
        ) {
          this.recalcularImpostosTodosItens();
        }
      }
    },
    openModalTabelaPreco() {
      this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', {
        cliente: {
          clienteid: this.getCapaPedido.clienteiderp,
          clienteiderp: this.getCapaPedido.clienteiderp,
        },
        representante: {
          representantenome: this.getCapaPedido.representantenome,
        },
      });
      this.$bvModal.show('modal-buscar-tabelapreco-info-pedido');
    },
    async onBlurTabelaPreco() {
      if (!this.showSalvar || this.getCapaPedido.pedidonumerointegracao !== 'RASCUNHO') return;

      const codigoDigitado = String(this.getCapaPedido.tabelaprecoid || '').trim();

      if (!codigoDigitado) {
        this.$store.commit('SLS_PedidosVendas/SET_CAPA_PEDIDO', {
          ...this.getCapaPedido,
          tabelaprecoid: '',
          tabelapreco_descricao: '',
        });
        return;
      }

      if (String(this._ultimaTabelaPrecoProcessada) === codigoDigitado) return;

      try {
        const clienteIdERP = this.getCapaPedido.clienteiderp;
        if (!clienteIdERP) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não encontrado',
              text: 'Não foi possível identificar o cliente do pedido.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        const tabelasList = await slsTabelaPrecoService.getTabelaPrecoByClienteIdERP(clienteIdERP, { perPage: 8000000 });

        if (!Array.isArray(tabelasList) || tabelasList.length === 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'Não foram encontradas tabelas de preço para este cliente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        const tabelaEncontrada = tabelasList.find(
          (t) => String(t.tabelapreco_id).trim() === codigoDigitado,
        );

        if (tabelaEncontrada) {
          this._ultimaTabelaPrecoProcessada = codigoDigitado;

          this.$store.commit('SLS_PedidosVendas/SET_CAPA_PEDIDO', {
            ...this.getCapaPedido,
            tabelaprecoid: tabelaEncontrada.tabelapreco_id,
            tabelapreco_descricao: tabelaEncontrada.tabelapreco_descricao,
          });

          if (this.getItensPedido.length > 0) {
            this.recalcularImpostosTodosItens();
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Tabela de preço não encontrada',
              text: `A tabela de preço "${codigoDigitado}" não foi encontrada para este cliente.`,
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.$store.commit('SLS_PedidosVendas/SET_CAPA_PEDIDO', {
            ...this.getCapaPedido,
            tabelaprecoid: '',
            tabelapreco_descricao: '',
          });
        }
      } catch (error) {
        console.error('Erro ao buscar tabela de preço:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao buscar a tabela de preço. Tente novamente.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      }
    },
    async onBlurCondPagamento() {
      // Só processa se for rascunho e estiver em modo edição
      if (!this.showSalvar || this.getCapaPedido.pedidonumerointegracao !== 'RASCUNHO') return;

      const codigoDigitado = String(this.getCapaPedido.condicaopagamentoid || '').trim();

      if (!codigoDigitado) {
        this.$store.commit('SLS_PedidosVendas/SET_CAPA_PEDIDO', {
          ...this.getCapaPedido,
          condicaopagamentoid: '',
          condicaoPagamentoDescricao: '',
        });
        return;
      }

      // Se o código não mudou, não faz nada
      if (String(this._ultimaCondPagtoProcessada) === codigoDigitado) return;

      try {
        const clienteId = this.getCapaPedido.clienteid;
        if (!clienteId) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não encontrado',
              text: 'Não foi possível identificar o cliente do pedido.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        const condPagtoList = await slsCondicaoPagamentoService.GetCondPagtoByClienteId(clienteId, { perPage: 8000000 });

        if (!Array.isArray(condPagtoList) || condPagtoList.length === 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'Não foram encontradas condições de pagamento para este cliente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        const condEncontrada = condPagtoList.find(
          (c) => String(c.condicaopagamentoid).trim() === codigoDigitado,
        );

        if (condEncontrada) {
          this._ultimaCondPagtoProcessada = codigoDigitado;

          // O v-model já atualizou condicaopagamentoid, então atualizamos só a descrição
          this.$store.commit('SLS_PedidosVendas/SET_CAPA_PEDIDO', {
            ...this.getCapaPedido,
            condicaopagamentoid: condEncontrada.condicaopagamentoid,
            condicaoPagamentoDescricao: condEncontrada.condicaopagamentodescricao,
          });

          // Recalcular impostos se houver itens
          if (this.getItensPedido.length > 0) {
            this.recalcularImpostosTodosItens();
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Condição de pagamento não encontrada',
              text: `A condição de pagamento "${codigoDigitado}" não foi encontrada para este cliente.`,
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.$store.commit('SLS_PedidosVendas/SET_CAPA_PEDIDO', {
            ...this.getCapaPedido,
            condicaopagamentoid: '',
            condicaoPagamentoDescricao: '',
          });
        }
      } catch (error) {
        console.error('Erro ao buscar condição de pagamento:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao buscar a condição de pagamento. Tente novamente.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      }
    },
    handleCondPagamentoSelected(item) {
      if (item && item.condicaopagamentoid) {
        const condAnterior = this.getCapaPedido.condicaopagamentoid;
        this._ultimaCondPagtoProcessada = String(item.condicaopagamentoid);
        this.$store.commit('SLS_PedidosVendas/SET_CAPA_PEDIDO', {
          ...this.getCapaPedido,
          condicaopagamentoid: item.condicaopagamentoid,
          condicaoPagamentoDescricao: item.condicaopagamentodescricao,
        });
        this.$bvModal.hide('modal-buscar-condpgto-info-pedido');

        // Se for rascunho e a condição mudou, recalcular impostos de todos os itens
        if (
          this.getCapaPedido.pedidonumerointegracao === 'RASCUNHO'
          && String(condAnterior) !== String(item.condicaopagamentoid)
          && this.getItensPedido.length > 0
        ) {
          this.recalcularImpostosTodosItens();
        }
      }
    },
    openModalCondPagamento() {
      // Prepara o store InfoPedido para que o modal consiga buscar os dados
      // O modal busca cliente.clienteid ou clienteiderp
      this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', {
        cliente: {
          clienteid: this.getCapaPedido.clienteid,
          clienteiderp: this.getCapaPedido.clienteiderp,
        },
        representante: {
            representantenome: this.getCapaPedido.representantenome
        }
      });
      this.$bvModal.show('modal-buscar-condpgto-info-pedido');
    },
    normalizeDateToISO(dateValue) {
      if (!dateValue) return new Date().toISOString().split('T')[0];
      if (typeof dateValue === 'string') {
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateValue)) {
          const [dd, mm, yyyy] = dateValue.split('/');
          return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
        }
        if (/^\d{4}-\d{2}-\d{2}/.test(dateValue)) {
          return dateValue.split('T')[0];
        }
        if (dateValue.includes('T')) {
          return dateValue.split('T')[0];
        }
      }
      try {
        const d = new Date(dateValue);
        if (!isNaN(d.getTime())) return d.toISOString().split('T')[0];
      } catch (e) { /* noop */ }
      return new Date().toISOString().split('T')[0];
    },
    ...mapActions('SLS_PedidosVendas', ['setFilters', 'retornaPedidoVendas', 'cancelarPedido', 'listarCapaPedido', 'salvarItensNovos', 'enderecoEntregaPedido', 'retornaItensPedido', 'clearFilters']),
    async recalcularImpostosTodosItens() {
      this.isRecalculandoImpostos = true;
      this.show = true;

      Swal.fire({
        title: 'Recalculando impostos',
        html: 'Recalculando impostos de todos os itens com a nova condição de pagamento. Por favor, aguarde...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const capa = this.getCapaPedido;
        const endereco = this.getEnderecoEntrega;

        const estabelecimentoid = capa.estabelecimentoId || '';
        const clienteNomeAbreviado = capa.clientenomeabreviado || '';
        const tabelaprecoid = capa.tabelaprecoid || '';
        const condicaopagamentoid = Number(capa.condicaopagamentoid || 0);
        const naturezaoperacaoid = capa.naturezaoperacaoidimposto || '6101';
        const canalvendaid = capa.canalvendaid || '';
        const ufid = endereco?.ufid || '';
        const cidade = endereco?.clienteenderecocidade || '';

        const baseUrl = await getTotvsBaseUrl();
        const url = `${baseUrl}/simular-Impostos-novo-metodo`;

        const itensPedido = JSON.parse(JSON.stringify(this.getItensPedido));
        let totalRecalculado = 0;
        let totalProcessados = 0;
        const totalItens = itensPedido.reduce((sum, item) => sum + (item.itens?.length || 0), 0);

        for (const item of itensPedido) {
          for (const subItem of item.itens) {
            totalProcessados++;
            Swal.update({
              html: `Recalculando item ${totalProcessados} de ${totalItens}...`,
            });

            const precoUnitario = parseFloat(
              String(subItem.precoUnitario || '0').replace(/[R$\s.]/g, '').replace(',', '.')
            ) || 0;

            try {
              const payload = {
                ttCabPedido: [{
                  'c-pr-cod-estabel': estabelecimentoid,
                  'c-pr-nome-abrev': clienteNomeAbreviado,
                  'c-pr-nat-operacao': naturezaoperacaoid,
                  'c-pr-cod-canal-venda': canalvendaid,
                  'c-pr-it-codigo': subItem.itemId,
                  'd-pr-quantidade': subItem.pedidoItemQuantidade,
                  'd-pr-vl-preori-ped': precoUnitario,
                  'd-pr-per-des-item': 0.0,
                  'p-simulacao': 0,
                  'p-uf-ds': ufid,
                  'p-cidade-ds': cidade,
                  'p-contr-icms': 0,
                  'p-tp-frete': 0,
                  'p-tp-tabpre': tabelaprecoid,
                  'p-cod-cond-pagto': condicaopagamentoid,
                  ttitempedido: [{ itCodigo: subItem.itemId }],
                }],
              };

              const response = await axios.post(url, payload, {
                headers: { 'Content-Type': 'application/json' },
              });

              if (response.data?.ttRetornoImposto?.[0]) {
                const retorno = response.data.ttRetornoImposto[0];
                const precoComImposto = retorno['d-pr-unitario'] || precoUnitario;
                const baseIcms = retorno['d-pr-base-icms'] || 0;
                const valorIcms = retorno['d-pr-valor-icms'] || 0;
                const natOperacao = retorno['c-pr-nat-operacao'] || naturezaoperacaoid;

                subItem.precoComImposto = precoComImposto;
                subItem.baseIcms = baseIcms;
                subItem.valorIcms = valorIcms;
                subItem.naturezaoperacaoidimposto = natOperacao;
                subItem.valorTotalComImposto = precoComImposto * subItem.pedidoItemQuantidade;
                subItem.pedidoitemtotalimposto = precoComImposto * subItem.pedidoItemQuantidade;
                subItem.pedidoitemprecoimposto = precoComImposto;
                subItem.pedidoitemprecounitarioimposto = precoComImposto;
              }
            } catch (err) {
              console.error(`Erro ao recalcular imposto do item ${subItem.itemId}:`, err);
            }
          }

          // Recalcular totais do item pai
          item.Qtde = item.itens.reduce((sum, si) => sum + parseInt(si.pedidoItemQuantidade), 0);
          item.ValorTotal = item.itens.reduce((sum, si) => {
            const pu = parseFloat(String(si.precoUnitario || '0').replace(/[R$\s.]/g, '').replace(',', '.')) || 0;
            return sum + (pu * si.pedidoItemQuantidade);
          }, 0);
          item.valorTotalComImposto = item.itens.reduce((sum, si) => sum + (si.valorTotalComImposto || 0), 0);
          item.PrecoComImposto = item.Qtde > 0 ? item.valorTotalComImposto / item.Qtde : 0;
          item.BaseIcms = item.itens.reduce((sum, si) => sum + (si.baseIcms || 0), 0);
          item.ValorIcms = item.itens.reduce((sum, si) => sum + (si.valorIcms || 0), 0);

          totalRecalculado += item.valorTotalComImposto;
        }

        // Atualizar store com os itens recalculados
        this.$store.commit('SLS_PedidosVendas/SET_ITENS_PEDIDO', itensPedido);

        // Atualizar capa do pedido com novos totais
        this.$store.commit('SLS_PedidosVendas/SET_CAPA_PEDIDO', {
          ...this.getCapaPedido,
          pedidovalortotal: totalRecalculado,
          pedidototalcomimpostos: totalRecalculado,
        });

        Swal.fire({
          title: 'Impostos recalculados!',
          text: `Todos os ${totalItens} itens foram recalculados com a nova condição de pagamento.`,
          icon: 'success',
          confirmButtonText: 'OK',
        });
      } catch (error) {
        console.error('Erro ao recalcular impostos:', error);
        Swal.fire({
          title: 'Erro',
          text: error.message || 'Erro ao recalcular impostos dos itens.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } finally {
        this.isRecalculandoImpostos = false;
        this.show = false;
      }
    },
    async detalhePedido(pedidoid, clienteid) {
      try {
        await this.listarCapaPedido(pedidoid);
        await this.retornaItensPedido(pedidoid);
        await this.enderecoEntregaPedido(clienteid);

        try {
          if (this.getCapaPedido && this.getCapaPedido.pedidonumerointegracao === 'RASCUNHO') {
            localStorage.setItem('activeDraftId', String(pedidoid));
          } else {
            const active = localStorage.getItem('activeDraftId');
            if (active && String(active) === String(pedidoid)) {
              localStorage.removeItem('activeDraftId');
            }
          }

          const prev = this.getCapaPedido?.pedidodataentregaprevista;
          const entrega = this.getCapaPedido?.pedidodataentrega;
          const canon = this.normalizeDateToISO(prev || entrega);
          this.$store.commit('SLS_PedidosVendas/SET_CAPA_PEDIDO', {
            ...this.getCapaPedido,
            pedidodataentrega: canon,
            pedidodataentregaprevista: canon,
          });
        } catch (e) {
          console.warn('Não foi possível atualizar activeDraftId nos detalhes:', e);
        }
      } catch (error) {
        console.error(error);
      }
    },
    handleDateChange(event) {
      if (!event) return;

      this.$store.commit('SLS_PedidosVendas/SET_CAPA_PEDIDO', {
        ...this.getCapaPedido,
        pedidodataentrega: event,
        pedidodataentregaprevista: event,
      });

      console.log('Data de entrega atualizada para:', event);
    },
    preventInvalidInput(event) {
      if (event.key === '0' && event.target.value === '') {
        event.preventDefault();
      }
      if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
        event.preventDefault();
      }
    },
    async handleQuantityInput(item, event) {
      let newQuantity = parseInt(event) || 1;
      const itemMultiplo = parseInt(item.itemMultiplo || 1);
      const minQuantity = itemMultiplo > 1 ? itemMultiplo : 1;

      if (newQuantity < minQuantity || isNaN(newQuantity) || newQuantity === 0) {
        newQuantity = minQuantity;
      }

      if (itemMultiplo > 1 && newQuantity % itemMultiplo !== 0) {
        newQuantity = Math.ceil(newQuantity / itemMultiplo) * itemMultiplo;
      }

      item.pedidoItemQuantidade = newQuantity;

      const precoUnitario = parseFloat(item.precoUnitario?.replace(/[R$\s.]/g, '').replace(',', '.')) || 0;
      const precoComImposto = parseFloat(item.precoComImposto) || precoUnitario;

      item.valorTotal = precoUnitario * newQuantity;
      item.valorTotalComImposto = precoComImposto * newQuantity;
      item.pedidoitemtotalimposto = precoComImposto * newQuantity;

      await this.recalcularTotaisItemPai(item);
      this.$store.commit('SLS_PedidosVendas/SET_ITENS_PEDIDO', [...this.getItensPedido]);
    },
    validateQuantityOnBlur(item) {
      const itemMultiplo = parseInt(item.itemMultiplo || 1);
      const minQuantity = itemMultiplo > 1 ? itemMultiplo : 1;

      if (!item.pedidoItemQuantidade || item.pedidoItemQuantidade < minQuantity) {
        item.pedidoItemQuantidade = minQuantity;
        this.handleQuantityInput(item, minQuantity);
      }
    },
    async incrementQuantity(item) {
      if (!this.isValidIncrement(item)) return;

      const itemMultiplo = parseInt(item.itemMultiplo || 1);
      const quantidadeAtual = parseInt(item.pedidoItemQuantidade) || 0;
      const novaQuantidade = itemMultiplo > 1
        ? quantidadeAtual + itemMultiplo
        : quantidadeAtual + 1;

      item.pedidoItemQuantidade = novaQuantidade;

      const precoUnitario = parseFloat(item.precoUnitario?.replace(/[R$\s.]/g, '').replace(',', '.')) || 0;
      const precoComImposto = parseFloat(item.precoComImposto) || precoUnitario;

      item.valorTotal = precoUnitario * novaQuantidade;
      item.valorTotalComImposto = precoComImposto * novaQuantidade;
      item.pedidoitemtotalimposto = precoComImposto * novaQuantidade;

      await this.recalcularTotaisItemPai(item);

      this.$store.commit('SLS_PedidosVendas/SET_ITENS_PEDIDO', [...this.getItensPedido]);
    },
    async decrementQuantity(item) {
      if (!this.isValidDecrement(item)) return;

      const itemMultiplo = parseInt(item.itemMultiplo || 1);
      const quantidadeAtual = parseInt(item.pedidoItemQuantidade) || 0;
      const minQuantity = itemMultiplo > 1 ? itemMultiplo : 1;

      if (quantidadeAtual > minQuantity) {
        const novaQuantidade = itemMultiplo > 1
          ? quantidadeAtual - itemMultiplo
          : quantidadeAtual - 1;

        item.pedidoItemQuantidade = novaQuantidade;

        const precoUnitario = parseFloat(item.precoUnitario?.replace(/[R$\s.]/g, '').replace(',', '.')) || 0;
        const precoComImposto = parseFloat(item.precoComImposto) || precoUnitario;

        item.valorTotal = precoUnitario * novaQuantidade;
        item.valorTotalComImposto = precoComImposto * novaQuantidade;
        item.pedidoitemtotalimposto = precoComImposto * novaQuantidade;

        await this.recalcularTotaisItemPai(item);

        this.$store.commit('SLS_PedidosVendas/SET_ITENS_PEDIDO', [...this.getItensPedido]);
      }
    },

    async recalcularTotaisItemPai(subItem) {
      const itensPedido = JSON.parse(JSON.stringify(this.getItensPedido));

      for (const item of itensPedido) {
        const subItemIndex = item.itens.findIndex((si) => si.itemId === subItem.itemId
          && si.des_cor === subItem.des_cor
          && si.desc_tamanho === subItem.desc_tamanho);

        if (subItemIndex !== -1) {
          item.itens[subItemIndex] = { ...item.itens[subItemIndex], ...subItem };

          item.Qtde = item.itens.reduce((sum, si) => sum + parseInt(si.pedidoItemQuantidade), 0);
          item.ValorTotal = item.itens.reduce((sum, si) => sum + (si.valorTotal || 0), 0);
          item.valorTotalComImposto = item.itens.reduce((sum, si) => sum + (si.valorTotalComImposto || 0), 0);
          item.PrecoComImposto = item.Qtde > 0 ? item.valorTotalComImposto / item.Qtde : 0;

          this.$store.commit('SLS_PedidosVendas/SET_ITENS_PEDIDO', itensPedido);
          break;
        }
      }
    },
    isValidIncrement(item) {
      if (!this.showSalvar) return false;

      const itemMultiplo = parseInt(item.itemMultiplo || 1);
      if (itemMultiplo <= 1) return true;

      // Verifica se a quantidade atual é múltipla do itemMultiplo
      return item.pedidoItemQuantidade % itemMultiplo === 0;
    },
    isValidDecrement(item) {
      if (!this.showSalvar) return false;

      const itemMultiplo = parseInt(item.itemMultiplo || 1);
      if (itemMultiplo <= 1) return true;

      const novaQuantidade = item.pedidoItemQuantidade - itemMultiplo;
      return novaQuantidade >= itemMultiplo && novaQuantidade % itemMultiplo === 0;
    },
    getMultiploTooltip(item) {
      const itemMultiplo = parseInt(item.itemMultiplo || 1);
      if (itemMultiplo <= 1) return '';
      return `Somente múltiplos de ${itemMultiplo} são permitidos`;
    },
    async removeItem(index) {
      if (!this.showSalvar) return;

      try {
        const result = await Swal.fire({
          title: 'Confirmar exclusão',
          text: 'Deseja realmente excluir este item?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, excluir',
          confirmButtonColor: '#EA5455',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          const itensPedido = [...this.getItensPedido];
          itensPedido.splice(index, 1);

          this.$store.commit('SLS_PedidosVendas/SET_ITENS_PEDIDO', itensPedido);
          await this.recalcularTotaisPedido();
        }
      } catch (error) {
        console.error('Erro ao remover item:', error);
      }
    },
    async removeSubItem(subItem) {
      if (!this.showSalvar) return;

      try {
        const result = await Swal.fire({
          title: 'Confirmar exclusão',
          text: 'Deseja realmente excluir este item?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, excluir',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          const itensPedido = [...this.getItensPedido];

          // Procurar o item pai no array
          for (const item of itensPedido) {
            const subItemIndex = item.itens.findIndex((si) => si.itemId === subItem.itemId
              && si.des_cor === subItem.des_cor
              && si.desc_tamanho === subItem.desc_tamanho);

            if (subItemIndex !== -1) {
              // Remover o subitem
              item.itens.splice(subItemIndex, 1);

              // Se não há mais subitens, remover o item pai
              if (item.itens.length === 0) {
                const itemIndex = itensPedido.indexOf(item);
                itensPedido.splice(itemIndex, 1);
              } else {
                // Recalcular totais do item pai
                item.Qtde = item.itens.reduce((sum, si) => sum + si.pedidoItemQuantidade, 0);
                item.ValorTotal = item.itens.reduce((sum, si) => sum + si.valorTotal, 0);
                item.valorTotalComImposto = item.itens.reduce(
                  (sum, si) => sum + si.valorTotalComImposto, 0,
                );
              }

              // Atualizar a store com o novo array
              this.$store.commit('SLS_PedidosVendas/SET_ITENS_PEDIDO', itensPedido);
              await this.recalcularTotaisPedido();
              break;
            }
          }
        }
      } catch (error) {
        console.error('Erro ao remover sub-item:', error);
      }
    },
    async recalcularTotaisPedido() {
      // Recalcular totais do pedido
      const valorTotal = this.getItensPedido.reduce(
        (sum, item) => sum + item.valorTotalComImposto, 0,
      );

      // Atualizar capa do pedido com novos totais
      this.$store.commit('SLS_PedidosVendas/SET_CAPA_PEDIDO', {
        ...this.getCapaPedido,
        pedidovalortotal: valorTotal,
        pedidototalcomimpostos: valorTotal,
      });
    },
    async cancelarAlteracoes() {
      this.showSalvar = false;
      await this.detalhePedido(this.$route.params.pedidoid, this.$route.params.clienteid);
    },
    async cancelar() {
      this.showSalvar = false;
      try {
        const isRascunho = this.getCapaPedido.pedidonumerointegracao === 'RASCUNHO';

        if (isRascunho) {
          const result = await Swal.fire({
            icon: 'warning',
            title: 'Deseja realmente excluir esse rascunho?',
            text: 'Essa ação não poderá ser desfeita!',
            showCancelButton: true,
            confirmButtonText: 'Excluir',
            confirmButtonColor: '#dc3545',
            cancelButtonText: 'Cancelar',
          });

          if (!result.isConfirmed) return;

          await slsPedidosService.deletePedido(this.getCapaPedido.pedidoid);

          await Swal.fire({
            icon: 'success',
            title: 'Rascunho excluído com sucesso!',
            showConfirmButton: false,
            timer: 1500,
          });

          this.$router.push({ name: 'pedidos-vendas' });
          this.clearFilters();
          return;
        }

        await this.cancelarPedido(this.getCapaPedido.pedidoid);

        await Swal.fire({
          title: 'Pedido cancelado com sucesso!',
          html: `Seu pedido foi cancelado com sucesso! Número do Pedido: <strong>#${this.getCapaPedido.pedidoid}</strong>`,
          icon: 'success',
          confirmButtonText: 'OK',
        });

        this.$router.push({ name: 'pedidos-vendas' });
        this.clearFilters();
      } catch (error) {
        Swal.fire({
          title: error?.response?.data?.title || 'Erro',
          text: error?.response?.data?.message || error?.message || 'Ocorreu um erro ao processar a solicitação.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    },
    async copiarPedido() {
      try {
        const result = await Swal.fire({
          title: 'Copiar pedido',
          text: 'Isso criará uma cópia do pedido atual. Deseja continuar?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim, copiar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#28C76F',
          cancelButtonColor: '#EA5455',
        });

        if (!result.isConfirmed) return;

        this.show = true;

        const novaDataEntrega = this.dataEntregaPadrao;

        const converterValorParaFloat = (valor) => {
          if (typeof valor === 'number') return valor;
          if (typeof valor === 'string') {
            return parseFloat(valor.replace(/[R$\s]/g, '').replace(/\./g, '').replace(',', '.'));
          }
          return valor;
        };

        const payload = {
          clienteid: this.getCapaPedido.clienteid,
          tipopedidoid: this.getCapaPedido.tipopedidoid,
          condicaopagamentoid: this.getCapaPedido.condicaopagamentoid,
          naturezaoperacaoid: this.getCapaPedido.naturezaoperacaoidimposto,
          tabelaprecoid: this.getCapaPedido.tabelaprecoid,
          pedidoobservacoes: this.getCapaPedido.pedidoobservacoes,
          pedidourgente: false,
          pedidodataentrega: novaDataEntrega,
          pedidodataentregaprevista: novaDataEntrega,
          pedidovalortotal: converterValorParaFloat(this.getCapaPedido.pedidovalortotal || this.getCapaPedido.pedidototalcomimpostos),
          tipoenderecoid: this.getEnderecoEntrega.tipoenderecoid || 'PADRAO',
          pedidooccliente: this.getCapaPedido.pedidooccliente,
          pedidoconsumidorfinal: true,
          pedidoprioridade: String(this.getCapaPedido.pedidoprioridade),
          canalvendaid: this.getCapaPedido.canalvendaid,
          cod_priori: parseInt(this.getCapaPedido.cod_priori),
          representanteid: String(this.getCapaPedido.representanteid),
          estabelecimentoid: String(this.getCapaPedido.estabelecimentoId),
          itemsPedido: this.getItensPedido.map((item) => ({
            CodMarca: parseInt(item.CodMarca),
            DescricaoMarca: item.DescricaoMarca,
            CodReferencia: item.CodReferencia,
            DescricaoReferencia: item.DescricaoReferencia,
            referencia: item.referencia,
            Qtde: parseInt(item.Qtde),
            PrecoUnitario: converterValorParaFloat(item.PrecoUnitario),
            ValorTotal: converterValorParaFloat(item.ValorTotal),
            PrecoComImposto: parseFloat(item.PrecoComImposto || 0),
            BaseIcms: parseFloat(item.BaseIcms || 0),
            ValorIcms: parseFloat(item.ValorIcms || 0),
            sequencia: parseInt(item.sequencia),
            itens: item.itens.map((subItem) => ({
              codMarca: parseInt(subItem.codMarca),
              familiaComercialId: subItem.familiaComercialId,
              cdncor: parseInt(subItem.cdncor),
              des_cor: subItem.des_cor,
              cdn_tamanho: subItem.cdn_tamanho,
              itemId: subItem.itemId,
              item_descricao: subItem.item_descricao,
              descricao_referencia: subItem.descricao_referencia,
              pedidoItemQuantidade: parseInt(subItem.pedidoItemQuantidade),
              marca: subItem.marca,
              embalagem: subItem.embalagem,
              cdn_embalagem: parseInt(subItem.cdn_embalagem),
              precoUnitario: converterValorParaFloat(subItem.precoUnitario),
              valorTotal: converterValorParaFloat(subItem.valorTotal),
              pedidoItemQuantidadeSaldo: parseInt(subItem.pedidoItemQuantidadeSaldo || 0),
              pedidoItemQuantidadeFaturada: parseInt(subItem.pedidoItemQuantidadeFaturada || 0),
              pedidoitemseq: parseInt(subItem.pedidoitemseq || 0),
              desc_tamanho: subItem.desc_tamanho,
              precoComImposto: parseFloat(subItem.precoComImposto || 0),
              baseIcms: parseFloat(subItem.baseIcms || 0),
              valorIcms: parseFloat(subItem.valorIcms || 0),
              itemMultiplo: parseInt(subItem.itemMultiplo || 1),
              naturezaoperacaoidimposto: String(subItem.naturezaoperacaoidimposto || 0),
              valorTotalComImposto: parseFloat(subItem.valorTotalComImposto || 0),
            })),
          })),
        };

        const response = await slsPedidosService.finalizarPedidoOperacao(payload);

        this.show = false;

        await Swal.fire({
          title: 'Pedido copiado com sucesso!',
          html: `Um novo pedido foi criado com sucesso! Número do Pedido: <strong>#${response.data.data.pedidoid}</strong>`,
          icon: 'success',
          confirmButtonText: 'OK',
        });

        this.clearFilters();
      } catch (error) {
        this.show = false;

        Swal.fire({
          title: error.response?.data?.title || 'Erro',
          text: error.response?.data?.message || 'Ocorreu um erro ao copiar o pedido',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    },
    formatarData(valor) {
      if (!valor) return '';
      const [data, horaCompleta] = valor.replace('Z', '').split('T');

      const [ano, mes, dia] = data.split('-');
      const hora = horaCompleta.split('.')[0];

      return `${dia}/${mes}/${ano} ${hora}`;
    },
    formatCurrency(value) {
      if (value === null || value === undefined || value === '') return 'R$ 0,00';
      const num = Number(value);
      if (Number.isNaN(num)) return String(value);
      return num.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
    normalizeMoneyValue(value) {
      if (value === null || value === undefined || value === '') return null;
      if (typeof value === 'number') return value;
      if (typeof value === 'string') {
        const cleaned = value.replace(/[R$\s]/g, '').replace(/\./g, '').replace(',', '.');
        const num = Number(cleaned);
        return Number.isNaN(num) ? null : num;
      }
      return null;
    },
    formatPedidoTotal() {
      const totalComImposto = this.getCapaPedido?.pedidototalcomimpostos;
      if (totalComImposto !== null && totalComImposto !== undefined && totalComImposto !== '') {
        return this.formatCurrency(totalComImposto);
      }
      return this.getCapaPedido?.pedidovalortotal || 'R$ 0,00';
    },
    formatItemTotal(totalComImposto, totalSemImposto) {
      const totalComImpostoNum = this.normalizeMoneyValue(totalComImposto);
      if (totalComImpostoNum !== null && totalComImpostoNum !== 0) {
        return this.formatCurrency(totalComImpostoNum);
      }

      const totalSemImpostoNum = this.normalizeMoneyValue(totalSemImposto);
      if (totalSemImpostoNum !== null) {
        return this.formatCurrency(totalSemImpostoNum);
      }

      return 'R$ 0,00';
    },
    getPrecoComImpostoExibicao(item) {
      if (!item) return 0;
      const precoComImposto = this.normalizeMoneyValue(item.PrecoComImposto ?? item.precoComImposto);
      if (precoComImposto !== null && precoComImposto !== 0) {
        return precoComImposto;
      }

      const precoUnitario = this.normalizeMoneyValue(item.PrecoUnitario ?? item.precoUnitario);
      return precoUnitario ?? 0;
    },
    async finalizarPedido() {
      this.show = true;

      try {
        const isRascunho = this.getCapaPedido.pedidonumerointegracao === 'RASCUNHO';

        const formatarData = (data) => {
          if (!data) return this.dataEntregaPadrao;

          if (typeof data === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data)) {
            return data;
          }

          if (typeof data === 'string' && data.includes('T')) {
            return data.split('T')[0];
          }

          if (typeof data === 'string' && data.includes('/')) {
            const [dia, mes, ano] = data.split('/');
            return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
          }

          return data;
        };

        const converterValorParaFloat = (valor) => {
          if (typeof valor === 'number') return valor;
          if (typeof valor === 'string') {
            return parseFloat(valor.replace(/[R$\s]/g, '').replace(/\./g, '').replace(',', '.'));
          }
          return valor;
        };

        const dataBruta = this.getCapaPedido.pedidodataentregaprevista || this.getCapaPedido.pedidodataentrega;
        const dataEntregaCanonica = formatarData(dataBruta);

        const payload = {
          clienteid: this.getCapaPedido.clienteid,
          tipopedidoid: this.getCapaPedido.tipoPedidoId,
          condicaopagamentoid: this.getCapaPedido.condicaopagamentoid,
          naturezaoperacaoid: this.getCapaPedido.naturezaoperacaoidimposto,
          tabelaprecoid: this.getCapaPedido.tabelaprecoid,
          pedidoobservacoes: this.getCapaPedido.pedidoobservacoes || '',
          pedidourgente: false,
          pedidodataentrega: dataEntregaCanonica,
          pedidodataentregaprevista: dataEntregaCanonica,
          pedidovalortotal: converterValorParaFloat(this.getCapaPedido.pedidovalortotal || this.getCapaPedido.pedidototalcomimpostos),
          pedidositsales: 'SUBMETIDO',
          tipoenderecoid: this.getEnderecoEntrega.tipoenderecoid || 'PADRAO',
          pedidooccliente: this.getCapaPedido.pedidooccliente || '',
          pedidoconsumidorfinal: true,
          pedidoprioridade: String(this.getCapaPedido.pedidoprioridade || '0'),
          canalvendaid: this.getCapaPedido.canalvendaid || '',
          cod_priori: parseInt(this.getCapaPedido.cod_priori || 0),
          representanteid: String(this.getCapaPedido.representanteid),
          estabelecimentoid: String(this.getCapaPedido.estabelecimentoId),
          itemsPedido: this.getItensPedido.map((item) => ({
            CodMarca: parseInt(item.CodMarca),
            DescricaoMarca: item.DescricaoMarca,
            CodReferencia: item.CodReferencia || item.referencia?.split('-')[0],
            DescricaoReferencia: item.DescricaoReferencia,
            referencia: item.referencia,
            Qtde: parseInt(item.Qtde),
            PrecoUnitario: converterValorParaFloat(item.PrecoUnitario),
            ValorTotal: converterValorParaFloat(item.ValorTotal),
            PrecoComImposto: parseFloat(item.PrecoComImposto || 0),
            BaseIcms: parseFloat(item.BaseIcms || 0),
            ValorIcms: parseFloat(item.ValorIcms || 0),
            sequencia: parseInt(item.sequencia),
            itens: item.itens.map((subItem) => ({
              codMarca: parseInt(subItem.codMarca),
              familiaComercialId: subItem.familiaComercialId,
              cdncor: parseInt(subItem.cdncor),
              des_cor: subItem.des_cor,
              cdn_tamanho: subItem.cdn_tamanho,
              itemId: subItem.itemId,
              item_descricao: subItem.item_descricao,
              descricao_referencia: subItem.descricao_referencia || item.DescricaoReferencia,
              pedidoItemQuantidade: parseInt(subItem.pedidoItemQuantidade),
              marca: subItem.marca,
              embalagem: subItem.embalagem,
              cdn_embalagem: parseInt(subItem.cdn_embalagem),
              precoUnitario: converterValorParaFloat(subItem.precoUnitario),
              valorTotal: converterValorParaFloat(subItem.valorTotal),
              pedidoItemQuantidadeSaldo: parseInt(subItem.pedidoItemQuantidadeSaldo || 0),
              pedidoItemQuantidadeFaturada: parseInt(subItem.pedidoItemQuantidadeFaturada || 0),
              pedidoitemseq: parseInt(subItem.pedidoitemseq || 0),
              desc_tamanho: subItem.desc_tamanho,
              precoComImposto: parseFloat(subItem.precoComImposto || subItem.pedidoitemprecoimposto || 0),
              baseIcms: parseFloat(subItem.baseIcms || 0),
              valorIcms: parseFloat(subItem.valorIcms || 0),
              itemMultiplo: parseInt(subItem.itemMultiplo || 1),
              naturezaoperacaoidimposto: String(subItem.naturezaoperacaoidimposto || this.getCapaPedido.naturezaoperacaoidimposto),
              valorTotalComImposto: parseFloat(subItem.valorTotalComImposto || subItem.pedidoitemtotalimposto || 0),
            })),
          })),
        };

        // Se não for rascunho, incluir o pedidoid no payload
        if (!isRascunho) {
          payload.pedidoid = this.getCapaPedido.pedidoid;
        }

        // Criar novo se for rascunho, atualizar se for pedido existente
        const response = await slsPedidosService.finalizarPedidoOperacao(payload);

        // Se for rascunho, deletar o rascunho após a criação do novo pedido
        if (isRascunho) {
          await slsPedidosService.deletePedido(this.getCapaPedido.pedidoid);
        }

        this.show = false;

        const totvsFlag = await getParametro('INTEGRACAO_TOTVS');
        if (String(totvsFlag) === '0' && this.$toast) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'A integração com o TOTVS está pausada para período de testes.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }

        await Swal.fire({
          title: 'Pedido finalizado com sucesso!',
          html: `Seu pedido foi finalizado com sucesso! Número do Pedido: <strong>#${response.data.data.pedidoid}</strong>`,
          icon: 'success',
          confirmButtonText: 'OK',
        });

        this.$router.push({ name: 'pedidos-vendas' });
      } catch (error) {
        this.show = false;
        Swal.fire({
          title: error.response?.data?.title || 'Erro',
          text: error.response?.data?.message || 'Ocorreu um erro ao finalizar o pedido',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    },
    async alterar() {
      this.showSalvar = true;
    },
    async salvarPedido() {
      if (this.isRecalculandoImpostos) {
        Swal.fire({
          title: 'Aguarde',
          text: 'O recálculo de impostos está em andamento. Por favor, aguarde antes de salvar.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
        return;
      }

      const toNumber = (value, fallback = 0) => {
        const num = this.normalizeMoneyValue(value);
        return num === null ? fallback : num;
      };

      this.showSalvar = false;
      this.show = true;

      if (this.getCapaPedido.pedidonumerointegracao === 'RASCUNHO') {
        try {
          // Atualiza dados de cabeçalho do rascunho (incluindo totais recalculados)
          await slsPedidosService.atualizarDadosPedido(this.getCapaPedido.pedidoid, {
            condicaopagamentoid: this.getCapaPedido.condicaopagamentoid,
            tabelaprecoid: this.getCapaPedido.tabelaprecoid,
            pedidooccliente: this.getCapaPedido.pedidooccliente,
            pedidoobservacoes: this.getCapaPedido.pedidoobservacoes,
            pedidovalortotal: toNumber(this.getCapaPedido.pedidovalortotal),
            pedidototalcomimpostos: toNumber(this.getCapaPedido.pedidototalcomimpostos),
            pedidoprioridade: String(this.getCapaPedido.pedidoprioridade || '0'),
          });
        } catch (error) {
          console.error('Erro ao atualizar cabeçalho do rascunho', error);
          this.showSalvar = true;
          Swal.fire({
            title: 'Erro ao atualizar dados',
            text: error.response?.data?.message || 'Erro ao atualizar dados do rascunho',
            icon: 'error',
            confirmButtonText: 'OK',
          });
          return;
        }
      }

      // Mapear itens com os valores atualizados da store
      const itensMapeados = this.getItensPedido.map((item) => ({
        ...item,
        // Recalcular a quantidade total do item pai baseado nos subitens
        Qtde: item.itens.reduce((sum, subItem) => sum + toNumber(subItem.pedidoItemQuantidade), 0),
        // Recalcular valor total baseado nos subitens
        ValorTotal: item.itens.reduce((sum, subItem) => {
          const quantidade = toNumber(subItem.pedidoItemQuantidade);
          const valorTotal = toNumber(subItem.valorTotal, toNumber(subItem.precoUnitario) * quantidade);
          return sum + valorTotal;
        }, 0),
        PrecoComImposto: toNumber(item.PrecoComImposto),
        BaseIcms: toNumber(item.BaseIcms),
        ValorIcms: toNumber(item.ValorIcms),
        valorTotalComImposto: item.itens.reduce((sum, subItem) => {
          const quantidade = toNumber(subItem.pedidoItemQuantidade);
          const precoComImposto = toNumber(subItem.precoComImposto, toNumber(subItem.precoUnitario));
          const total = toNumber(subItem.valorTotalComImposto, precoComImposto * quantidade);
          return sum + total;
        }, 0),
        itens: item.itens.map((subItem) => {
          const quantidade = parseInt(subItem.pedidoItemQuantidade, 10) || 0;
          const precoUnitario = toNumber(subItem.precoUnitario);
          const precoComImposto = toNumber(subItem.precoComImposto, precoUnitario);

          return {
            ...subItem,
            pedidoItemQuantidade: quantidade,
            // Recalcular valores baseados na quantidade atual
            valorTotal: precoUnitario * quantidade,
            valorTotalComImposto: precoComImposto * quantidade,
            pedidoitemprecoimposto: toNumber(subItem.precoComImposto, toNumber(subItem.pedidoitemprecoimposto)),
            pedidoitemtotalimposto: precoComImposto * quantidade,
            pedidoitemprecounitarioimposto: toNumber(subItem.precoComImposto, toNumber(subItem.pedidoitemprecounitarioimposto)),
            precoComImposto: toNumber(subItem.precoComImposto),
            baseIcms: toNumber(subItem.baseIcms),
            valorIcms: toNumber(subItem.valorIcms),
            naturezaoperacaoidimposto: subItem.naturezaoperacaoidimposto || 0,
          };
        }),
      }));

      // Recalcular total geral do pedido
      const valorTotalPedido = itensMapeados.reduce((sum, item) => sum + toNumber(item.valorTotalComImposto), 0);

      // Atualizar dados do pedido com o novo valor total
      const dadosPedidoAtualizados = {
        ...this.getCapaPedido,
        pedidovalortotal: valorTotalPedido,
        pedidototalcomimpostos: valorTotalPedido,
      };

      try {
        await this.salvarItensNovos({
          dataPedido: dadosPedidoAtualizados,
          itens: itensMapeados,
        });

        Swal.fire({
          title: 'Pedido Salvo com sucesso!',
          html: `Seu pedido foi alterado com sucesso! Número do Pedido: <strong>#${this.getCapaPedido.pedidoid}</strong>`,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          // Recarregar dados após salvar
          this.detalhePedido(this.getCapaPedido.pedidoid, this.getCapaPedido.clienteid);
        });
      } catch (error) {
        this.showSalvar = true; // Reativar modo edição em caso de erro
        Swal.fire({
          title: error.response?.data?.title || 'Erro',
          text: error.response?.data?.message || 'Erro ao salvar o pedido',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } finally {
        this.show = false;
      }
    },
    async openModal() {
      this.$refs['adicionar-editar-itens-pedido-existente'].show('novo', null);
    },
    async voltar() {
      await this.clearFilters();
    },
  },
  computed: {
    ...mapGetters('SLS_PedidosVendas', {
      getCapaPedido: 'getCapaPedido',
      getItensPedido: 'getItensPedido',
      getEnderecoEntrega: 'getEnderecoEntrega',
    }),
    prioridadesPedidoOptions() {
      const prioridades = this.$store.getters['SLSEsPriori/GET_PRIORIDADES_PEDIDO'] || [];
      return prioridades.map((p) => ({
        value: String(p.cod_priori),
        text: `${p.Descricao || p.descricao}`,
      }));
    },
    dataEntregaPadrao() {
      const date = new Date();
      date.setDate(date.getDate() + 7);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    dataEntregaExibicao() {
      let dataAtual = this.getCapaPedido.pedidodataentrega;

      if (!dataAtual) {
        return this.dataEntregaPadrao;
      }

      if (typeof dataAtual === 'string' && dataAtual.includes('/')) {
        const [dia, mes, ano] = dataAtual.split('/');
        dataAtual = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
      }

      const hoje = new Date().toISOString().split('T')[0];
      if (dataAtual < hoje) {
        console.warn('Data de entrega está no passado, usando data padrão');
        return this.dataEntregaPadrao;
      }

      return dataAtual;
    },
    fields() {
      const baseFields = [
        'mostrar_detalhes',
        { key: 'DescricaoMarca', label: 'Marca', sortable: true },
        { key: 'referencia', label: 'Referência', sortable: true },
        { key: 'sequencia', label: 'Sequência', sortable: true },
        { key: 'PrecoComImposto', label: 'Valor Unitário Final', sortable: true },
        { key: 'Qtde', label: 'Quantidade', sortable: true },
        { key: 'valorTotalComImposto', label: 'Valor Total Final', sortable: true },
      ];

      if (this.showSalvar) {
        baseFields.push(
          // { key: 'editar', label: 'Editar', sortable: false },
          { key: 'excluir', label: 'Excluir', sortable: false },
        );
      }

      return baseFields;
    },

    fieldsSub() {
      const baseFieldsSub = [
        { key: 'itemId', label: 'Código', sortable: true },
        { key: 'item_descricao', label: 'Descrição', sortable: true },
        { key: 'marca', label: 'Marca', sortable: true },
        { key: 'des_cor', label: 'Cor', sortable: true },
        { key: 'embalagem', label: 'Embalagem', sortable: true },
        { key: 'pedidoItemQuantidade', label: 'QTD', sortable: true },
        { key: 'precoComImposto', label: 'Valor Unitário Final', sortable: true },
        { key: 'valorTotalComImposto', label: 'Valor Total Final', sortable: true },
        { key: 'pedidoItemQuantidadeSaldo', label: 'QTD Saldo', sortable: true },
        { key: 'pedidoItemQuantidadeFaturada', label: 'QTD Faturado', sortable: true },
      ];

      if (this.showSalvar) {
        baseFieldsSub.push({ key: 'excluir', label: 'Excluir', sortable: false });
      }

      return baseFieldsSub;
    },
    valorTotalFormatado() {
      return this.formatPedidoTotal();
    },
    ...mapGetters({
      getPedidoVendas: 'SLS_PedidosVendas/getPedidoVendas',
      getCapaPedido: 'SLS_PedidosVendas/getCapaPedido',
      getEnderecoEntrega: 'SLS_PedidosVendas/getEnderecoEntrega',
      getItensPedido: 'SLS_PedidosVendas/getItensPedido',
      getlistarTabelaItens: 'intensPedido/getlistarTabelaItens',
    }),
    botoesExibir() {
      const statusPedido = this.getCapaPedido?.pedidoSitSales;
      const statusPedidoComercial = this.getCapaPedido?.pedidositcomercial;

      const botoesPorStatus = {
        CANCELADO: ['Voltar'],
        DIGITADO: ['Voltar', 'Alterar', 'Finalizar', 'Cancelar', 'Copiar'],
        EXCLUIDO: ['Voltar'],
        INTEGRADO: ['Voltar', 'Copiar'],
        ENVIADO: ['Voltar', 'Copiar'],
        RECALCULAR: ['Voltar', 'Cancelar', 'Copiar', 'Recalcular'],
        REJEITADO: ['Voltar', 'Alterar', 'Finalizar', 'Cancelar', 'Copiar'],
        SUBMETIDO: ['Voltar', 'Copiar'],
        'PRÉ-PEDIDO': ['Voltar', 'Finalizar', 'Alterar', 'Cancelar'],
        RASCUNHO: ['Voltar', 'Finalizar', 'Alterar', 'Cancelar'],
      };

      // Se o status comercial for ENVIADO, use os botões para ENVIADO
      if (statusPedidoComercial === 'ENVIADO') {
        return botoesPorStatus.ENVIADO;
      }

      // Caso contrário, use o status do pedidositsales
      return statusPedido ? botoesPorStatus[statusPedido] : [];
    },
  },
};
</script>
<style scoped>
.rotate-icon {
  transform: rotate(90deg);
}
</style>
